// constants
import { WhoAreWeActionTypes } from "./constants";

export interface WhoAreWeActionType {
  type:
    | WhoAreWeActionTypes.API_RESPONSE_SUCCESS
    | WhoAreWeActionTypes.API_RESPONSE_ERROR
    | WhoAreWeActionTypes.UPDATE_WHO_ARE_WE_DATA
    | WhoAreWeActionTypes.CREATE_WHO_ARE_WE_DATA
    | WhoAreWeActionTypes.GET_WHO_ARE_WE_DATA
    | WhoAreWeActionTypes.DELETE_WHO_ARE_WE_DATA;
  payload: {} | string;
}

interface whoAreWeDetails {
  id: string;
  experience: string;
  users: string;
  courses: string;
}

// common success
export const whoAreWeDataApiResponseSuccess = (
  actionType: string,
  data: whoAreWeDetails | {}
): WhoAreWeActionType => ({
  type: WhoAreWeActionTypes.API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});
// common error
export const whoAreWeDataApiResponseError = (
  actionType: string,
  error: string
): WhoAreWeActionType => ({
  type: WhoAreWeActionTypes.API_RESPONSE_ERROR,
  payload: { actionType, error },
});

export const createWhoAreWeData = (
  experience: string,
  users: string,
  courses: string,
  file: any,
  head: string,
  subhead: string,
  head_ar: string,
  subhead_ar: string
): WhoAreWeActionType => ({
  type: WhoAreWeActionTypes.CREATE_WHO_ARE_WE_DATA,
  payload: {
    experience,
    users,
    courses,
    file,
    head,
    subhead,
    head_ar,
    subhead_ar,
  },
});

export const getWhoAreWeData = (): WhoAreWeActionType => ({
  type: WhoAreWeActionTypes.GET_WHO_ARE_WE_DATA,
  payload: {},
});

export const deleteWhoAreWeData = (id: string): WhoAreWeActionType => ({
  type: WhoAreWeActionTypes.DELETE_WHO_ARE_WE_DATA,
  payload: { id },
});
export const updateWhoAreWeData = (
  id: string,
  experience: string,
  users: string,
  courses: string,
  file: any,
  head: string,
  subhead: string,
  head_ar: string,
  subhead_ar: string
): WhoAreWeActionType => ({
  type: WhoAreWeActionTypes.UPDATE_WHO_ARE_WE_DATA,
  payload: { id, experience, users, courses, file, head, subhead ,head_ar, subhead_ar},
});
